import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import WhatsAppButton from './WhatsAppButton'

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/portfolio', label: 'Portfolio' },
  { path: '/services', label: 'Services' },
  { path: '/blog', label: 'Blog' },
  { path: '/demo', label: 'Demo' },
  { path: '/contact', label: 'Contact Us' },
]

const megaServices = [
  { path: '/services/web-development', title: 'Web Development' },
  { path: '/services/ai-ml-engineer', title: 'AI/ML Engineering' },
  { path: '/services/mobile-apps', title: 'Mobile Apps' },
  { path: '/services/ai-automation', title: 'AI Automation' },
]

const footerLinks = [
  { path: '/about', label: 'About' },
  { path: '/services', label: 'Services' },
  { path: '/#faq', label: 'FAQ' },
  { path: '/portfolio', label: 'Portfolio' },
  { path: '/blog', label: 'Blog' },
  { path: '/demo', label: 'Demo' },
  { path: '/contact', label: 'Contact' },
]

const Layout = ({ children }) => {
  const location = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const [megaOpen, setMegaOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const isHomePage = location.pathname === '/'

  const isActive = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname === path || location.pathname.startsWith(path + '/')

  useEffect(() => {
    setMenuOpen(false)
    setMegaOpen(false)
  }, [location.pathname])

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div className="site-shell">
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'border-b border-white/10 bg-[#0a0a0a]/92 shadow-[0_8px_28px_rgba(0,0,0,0.45)] backdrop-blur-xl'
            : 'bg-transparent'
        }`}
      >
        <div className="container-main">
          <div className="flex h-[86px] items-center justify-between gap-4">
            <Link to="/" className="shrink-0">
              <img src="/images/logo-white.png" alt="MindVista" className="h-14 w-auto" />
            </Link>

            <nav className="hidden items-center gap-1 lg:flex">
              {navLinks.map((link) => {
                if (link.path === '/services') {
                  return (
                    <div
                      key={link.path}
                      className="relative"
                      onMouseEnter={() => setMegaOpen(true)}
                      onMouseLeave={() => setMegaOpen(false)}
                    >
                      <Link
                        to={link.path}
                        className={`rounded-full px-4 py-2 text-sm font-semibold ${
                          isActive('/services') ? 'text-[rgb(249,193,37)]' : 'text-white/85 hover:text-[rgb(249,193,37)]'
                        }`}
                      >
                        Services
                      </Link>

                      {megaOpen && (
                        <div className="absolute left-1/2 top-12 w-[620px] -translate-x-1/2 rounded-2xl border border-white/10 bg-[#101010]/95 p-4 shadow-2xl backdrop-blur-xl">
                          <div className="grid grid-cols-4 gap-3">
                            {megaServices.map((service) => (
                              <Link
                                key={service.path}
                                to={service.path}
                                className="rounded-xl border border-white/10 bg-[#161616] px-3 py-4 text-center text-sm font-semibold text-white/90 hover:border-[rgb(249,193,37)]/50 hover:text-[rgb(249,193,37)]"
                              >
                                {service.title}
                              </Link>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                }

                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`rounded-full px-4 py-2 text-sm font-semibold ${
                      isActive(link.path) ? 'text-[rgb(249,193,37)]' : 'text-white/85 hover:text-[rgb(249,193,37)]'
                    }`}
                  >
                    {link.label}
                  </Link>
                )
              })}
            </nav>

            <div className="hidden items-center gap-3 lg:flex">
              <a href="mailto:business@mindvista.io" className="btn-outline p-2.5" aria-label="email">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </a>
              <Link to="/contact" className="btn-outline">Contact Us</Link>
            </div>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/25 bg-white/5 text-white lg:hidden"
              aria-label="menu"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {menuOpen && (
            <div className="mb-4 rounded-2xl border border-white/10 bg-[#101010] p-3 lg:hidden">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block rounded-xl px-3 py-2 text-sm font-semibold ${
                    isActive(link.path) ? 'bg-[rgb(249,193,37)]/12 text-[rgb(249,193,37)]' : 'text-white/85 hover:bg-white/5'
                  }`}
                >
                  {link.label}
                </Link>
              ))}

              <div className="mt-3 grid grid-cols-2 gap-2">
                <a href="mailto:business@mindvista.io" className="btn-outline w-full justify-center text-sm">Email</a>
                <Link to="/contact" className="btn-primary w-full justify-center text-sm">Contact Us</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      <main className={`${isHomePage ? '' : 'page-yellow-leaks'} pt-[86px]`}>{children}</main>

      <footer className="border-t border-white/10 bg-[#0a0a0a]">
        <div className="container-main py-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <img src="/images/logo-white.png" alt="MindVista" className="h-10 w-auto" />
            <a href="mailto:business@mindvista.io" className="text-lg font-semibold text-white hover:text-[rgb(249,193,37)]">
              business@mindvista.io
            </a>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-4">
            <div className="flex flex-wrap gap-4 text-sm text-[#9d9d9d]">
              {footerLinks.map((link) => (
                <Link key={link.path} to={link.path} className="hover:text-[rgb(249,193,37)]">
                  {link.label}
                </Link>
              ))}
            </div>

            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white hover:border-[rgb(249,193,37)] hover:text-[rgb(249,193,37)]"
              aria-label="LinkedIn"
            >
              in
            </a>
          </div>
        </div>
      </footer>

      <WhatsAppButton />
    </div>
  )
}

export default Layout


